import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CallAPI from "../../../services/apiCalls";
import useUserStore from "../../../utils/storeApp";
import $ from "jquery";

const Npi = ({ userEdit }) => {
  const navigate = useNavigate();
  const { userRole, userToken, SetSharedObject } = useUserStore((state) => ({
    userRole: state.userRole,
    userToken: state.userToken,
    SetSharedObject: state.SetSharedObject,
  }));
  const [npiResult, SetNpiResult] = useState([]);
  const [processing, SetProcessing] = useState(false);
  const [notExists, SetNotExists] = useState(false);
  const [answers, setAnswers] = useState({ NPI: "" });
  const setAnswer = async (questionId, answer, chck) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };
  const SearchNpi = async () => {
    if (answers.NPI === "") {
      SetNotExists(false);
      return;
    }
    SetProcessing(true);
    SetNotExists(false);
    let call =
      "/organization/SearchNPI?searchNPI=" + answers.NPI + "&npiType=2";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let dt = res.data.data;
      if (dt && Object.keys(dt).length > 0 && dt.constructor === Object) {
        let o = {
          NPI: dt.npi,
          Name: dt.providerOrganizationName,
          Addresses: {
            FirstLine: dt.providerFirstLineBusinessMailingAddress,
            SecondLine: "",
            City: dt.providerBusinessMailingAddressCityName,
            State: dt.providerBusinessMailingAddressStateCode,
            County: "",
            PostalCode: dt.providerBusinessMailingAddressPostalCode,
            Country: dt.providerBusinessMailingAddressCountryCode,
            Phone: dt.providerBusinessPracticeLocationAddressTelephoneNumber,
            PhoneExt: "",
            Fax: dt.providerBusinessPracticeLocationAddressFaxNumber,
            FaxExt: "",
            IsCertAddress: false,
            AddressType: 0,
            IsValid: false,
          },
        };
        SetNpiResult(o);
        $("#npiResultModal").modal("show");
      } else {
        SetNotExists(true);
      }
    } else if (res.status === "SERVERERROR") {
      SetNotExists(true);
      SetProcessing(false);
    }
    SetProcessing(false);
  };
  const SelectNpi = () => {
    userEdit(npiResult);
    $("#npiResultModal").modal("hide");
  };
  function formatPhoneNumber(value) {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  }
  return (
    <div className="Npi">
      <div className="field-wrapper npi-container ">
        <label for="npi" className="spacer-margin5 blk-clr">
          NPI:
        </label>
        <input
          className="form-control w-md6 spacer-inline"
          name="npi"
          id="npi"
          type="search"
          placeholder="Enter 10 digit ID"
          onChange={(el) => {
            if (el.target.value === "") SetNotExists(false);
            setAnswer("NPI", el.target.value);
          }}
        />
        <a
          href="javascript:void(0);"
          onClick={SearchNpi}
          type="button"
          className="btn btn-primary spacer-margin2"
          data-toggle="modal"
        >
          Search
        </a>
        {processing ? <div className="loading"></div> : null}

        {notExists ? (
          <div className="alert alert-danger">
            We could not connect or find NPI {answers.NPI} you entered. Please
            double check your number and try again.
          </div>
        ) : null}
      </div>
      <div
        className="modal fade"
        id="npiResultModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="NPI Results"
        aria-hidden="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title" id="myModalLabel">
                {" "}
                NPI Lookup{" "}
              </div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                {" "}
                <span aria-hidden="false">&times;</span>{" "}
              </button>
            </div>
            <div className="modal-body">
              <div className="modal-content-form">
                <div className="descript-container">Here is what we found.</div>
                <div className="field-wrapper">
                  <label>NPI ID:</label> {npiResult.NPI} <br />
                  <label>Name:</label> {npiResult.Name}
                  <br />
                  <label>Address 1:</label> {npiResult.Addresses?.FirstLine}
                  {/*<br />*/}
                  {/*<label>Address 2:</label>*/}
                  <br />
                  <label>City:</label> {npiResult.Addresses?.City}
                  <br />
                  <label>State:</label> {npiResult.Addresses?.State}
                  <br />
                  <label>Zip:</label> {npiResult.Addresses?.PostalCode}
                  <br />
                  <label>Phone:</label>
                  {formatPhoneNumber(npiResult.Addresses?.Phone)}
                  <br />
                  <label>Fax:</label>{" "}
                  {formatPhoneNumber(npiResult.Addresses?.Fax)}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={SelectNpi}
              >
                {" "}
                Select{" "}
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-dismiss="modal"
              >
                {" "}
                Cancel{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Npi;
